import { Component, defineComponent } from '@decify/cell-shopify/client';
import './SiteHeaderNavigation.scss';
export const siteHeaderNavigationName = 'SiteHeaderNavigation';
export const siteHeaderNavigationTagName = 'cell-component-site-header-navigation';
export class SiteHeaderNavigation extends Component {
    openMegaMenuElement = null;
    constructor() {
        super(siteHeaderNavigationName);
        this.openMegaMenuElement = null;
        this.handleItemMouseEnter = this.handleItemMouseEnter.bind(this);
        this.openMegaMenu = this.openMegaMenu.bind(this);
        this.closeMegaMenu = this.closeMegaMenu.bind(this);
    }
    componentDidMount() {
        this.itemWithMegaMenuElements.forEach((item) => {
            item.addEventListener('mouseenter', this.handleItemMouseEnter);
        });
    }
    handleItemMouseEnter(event) {
        const itemElement = event.currentTarget;
        // Sanity check.
        if (!itemElement || !(itemElement instanceof HTMLElement))
            return;
        this.openMegaMenu(itemElement);
    }
    openMegaMenu(itemElement) {
        const itemControlElement = itemElement.querySelector('[aria-controls]');
        if (!itemControlElement) {
            throw new Error('SiteHeaderNavigation item must have an element with an aria-controls attribute.');
        }
        const itemControlledElement = document.getElementById(itemControlElement.getAttribute('aria-controls') || '');
        if (!itemControlledElement) {
            throw new Error('SiteHeaderNavigation item must have an element with an ID matching the aria-controls attribute.');
        }
        // If the mega menu is already open, don't do anything.
        if (this.openMegaMenuElement === itemControlledElement)
            return;
        this.openMegaMenuElement = itemControlledElement;
        let openingTimeout = setTimeout(() => {
            itemControlledElement.removeAttribute('hidden');
            const mouseleaveListener = (event) => {
                if (event.relatedTarget) {
                    this.closeMegaMenu();
                    itemElement.removeEventListener('mouseleave', mouseleaveListener);
                }
            };
            const mouseleaveDocumentListener = () => {
                this.closeMegaMenu();
                document.removeEventListener('mouseleave', mouseleaveDocumentListener);
            };
            itemElement.addEventListener('mouseleave', mouseleaveListener);
            document.documentElement.addEventListener('mouseleave', mouseleaveDocumentListener);
            openingTimeout = null;
        }, 100);
        itemElement.addEventListener('mouseleave', () => {
            if (openingTimeout) {
                clearTimeout(openingTimeout);
                openingTimeout = null;
            }
        }, { once: true });
        window.addEventListener('scroll', this.closeMegaMenu, { once: true });
    }
    closeMegaMenu() {
        if (!this.openMegaMenuElement)
            return;
        this.openMegaMenuElement.setAttribute('hidden', '');
        this.openMegaMenuElement = null;
    }
    get itemWithMegaMenuElements() {
        return this.querySelectorAll('.SiteHeaderNavigationItem--HasMegaMenu');
    }
}
defineComponent(siteHeaderNavigationTagName, SiteHeaderNavigation);
